var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .653.653 0 4.44 3.787 8.227 0l.653.653-4.44 4.44z"
  })));
};
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5IDYiPgogIDxwYXRoIGQ9Ik0xLjUyNTg4ZS0wNSAwLjY1Mjc0N0wwLjY1Mjc2MyAtMy41OTYyNGUtMDdMNC40NDAwMSAzLjc4NzI1TDguMjI3MjYgLTIuODUzMjVlLTA4TDguODggMC42NTI3NDdMNC40NDAwMSA1LjA5Mjc0TDEuNTI1ODhlLTA1IDAuNjUyNzQ3WiIgLz4KPC9zdmc+";